// Module
var code = "<div class=\"body main sign-in ptj-container ptj-container-login\"> <header-error v-if=\"!isFaqLayout\"/> <router-view/> <modal-message v-if=\"!isFaqLayout\"/> <loading/> <main-footer v-if=\"!isFaqLayout\"/> </div> ";
// Exports
export default code;